var UlAnalytics = function() {
  var sendAnalytics = function(apiHostname, apiKey, activity) {
    var xhr = new XMLHttpRequest();

    xhr.open("POST", apiHostname + "/api/v3/analytics");
    xhr.setRequestHeader("Content-Type", "application/json");
    xhr.setRequestHeader("X-Api-Key", apiKey);
    xhr.setRequestHeader("Authorization", "Bearer " + window.CookiePolicy.getCookie("Bearer"));
    xhr.send(JSON.stringify({ activity: activity }));
  }

  var process = function(hostname, apiKey) {
    var bearerToken = window.CookiePolicy.getCookie("Bearer");

    if (bearerToken.length === 0) {
      return;
    }

    var activity = "";

    if (window.location.pathname.startsWith("/poradna-lekare/")) {
      activity = "open_consultation_response";
    } else if (window.location.pathname.startsWith("/clanek/")) {
      activity = "open_article_old_web";
    }

    if (activity.length !== 0) {
      window.setTimeout(function() {
        sendAnalytics(hostname, apiKey, activity);
      }, 5000);
    }
  }

  return {
    process: process
  };
}();

UL.register(UlAnalytics);
